import { render, staticRenderFns } from "./OfertaStatus.vue?vue&type=template&id=0da61b8c&scoped=true"
import script from "./OfertaStatus.vue?vue&type=script&lang=js"
export * from "./OfertaStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da61b8c",
  null
  
)

export default component.exports